import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImportRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.6 5.6h5.6V10c0 2 1.6 3.6 3.6 3.6h4.4v12q-.1.7-.8.8H9.6a1 1 0 0 1-.8-.8v-2.4H6.4v2.4c0 1.8 1.4 3.2 3.2 3.2h12.8c1.8 0 3.2-1.4 3.2-3.2v-13q0-1.4-1-2.3l-6-6.2a3 3 0 0 0-2.3-.9H9.6a3 3 0 0 0-3.2 3.2V16h2.4V6.4q.1-.7.8-.8m8 1 4.6 4.6h-3.4q-1.1 0-1.2-1.2zm-14.4 13q0 1.1 1.2 1.2h11.1L14 22.4a1.2 1.2 0 0 0 1.7 1.6l3.6-3.6c.4-.4.4-1.2 0-1.6L15.7 15a1.2 1.2 0 0 0-1.7 1.7l1.5 1.6H4.4q-1.1 0-1.2 1.2" })
});
export default SvgImportRegularIcon;
